import React from "react";
import classNames from "classnames";
import FieldLabel from "../base/FieldLabel";
import Input from "../base/Input";


const TextField = React.forwardRef((props, ref) => {

  const {
    className,
    children,
    valid,
  } = props;

  // Unexpected things can happen when we pass every single prop to the input field,
  // so collect just the appropriate fields to pass
  const inputProps = {
    id: props.id,
    type: props.type,
    name: props.name,
    placeholder: props.placeholder,
    onChange: props.onChange,
    value: props.value,
    maxLength: props.maxLength,
    autoComplete: props.autoComplete,
    dataAutomationId: props.dataAutomationId,
    autoFocus: props.autoFocus
  }

  const inputClass = classNames("form-input", {
    "form-input--error": !valid
  });

  return (
    <div className={`${inputClass} ${className || ""}`}>
      <FieldLabel {...props} />
      <Input {...inputProps} ref={ref}/>
      <React.Fragment>
        {children}
      </React.Fragment>
    </div>);
});

TextField.displayName = "TextField";

/* istanbul ignore next */
TextField.defaultProps = {
  autoFocus: false
};

export default TextField;
